import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    banners: {},
    isLoading: false,
   error :null
}

const getBannersSlice = createSlice({
    name: 'banners',
    initialState,
    reducers:{
        bannersPending: (state) => {
            state.isLoading = true;
        },
        bannersSuccess: (state, {payload}) => {
            state.isLoading = false;
            state.banners = payload?.result;
            state.error = null;
        },
        bannersFail: (state, {payload}) => {
            state.isLoading = false;
            state.error = payload;
        }
    }
})

export const {bannersPending, bannersSuccess, bannersFail} = getBannersSlice.actions

export default getBannersSlice.reducer